import { TextWithTooltip } from 'hooks/TextWithTooltip';
import styles from './BannerErrorEmployeds.module.scss';
import classNames from 'classnames';

export const BannerErrorEmployeds = ({
  content,
  colorBanner,
}: {
  content: string;
  colorBanner?: string;
}) => {
  const isDanger = content === 'Бывший сотрудник';
  return (
    <TextWithTooltip
      content={content}
      className={classNames(
        styles.contractBanner,
        isDanger && styles.danger,
        colorBanner && styles[colorBanner],
      )}
    />
  );
};
